import { api } from '../../base';
import { IQuestionAnswer } from '../../common';

export const fetchCreateJobCompanysList = () => {
    return api.get({ url: `tools/create-job-companys-list/` });
};

export const fetchCreateJobQuestionsCategories = (companyId: string) => {
    return api.get({
        url: `tools/create-job-questions-categories/${companyId}/`,
    });
};

export const createCompany = (payload: { name: string }) => {
    return api.post({
        url: `tools/company-profiles/`,
        data: payload,
    });
};

export const fetchCompanyCategories = (companyId: string) => {
    return api.get({
        url: `tools/question-templates/${companyId}/unanswered/`,
    });
};

export const fetchCompanyQuestionsHistory = (companyId: string) => {
    return api.get({
        url: `tools/question-templates/${companyId}/answered/`,
    });
};

export const fetchActiveChatQuestions = () => {
    return api.get({
        url: `/tools/chat-question-templates/`,
    });
};

//asd
export const fetchChatsList = (companyId: string) => {
    return api.get({
        url: `/tools/chats/${companyId}/`,
    });
};

export const fetchChatMessages = (companyId: string, chatId: string) => {
    return api.get({
        url: `/tools/chats/${companyId}/${chatId}/history/`,
    });
};

export const sendMessage = (
    companyId: string,
    chatId: string,
    payload: IQuestionAnswer
) => {
    return api.post({
        url: `/tools/chats/${companyId}/${chatId}/reply/`,
        data: payload,
    });
};

export const companyQuestionAnswer = (
    companyId: string,
    questionId: string,
    answer: string
) => {
    return api.post({
        url: `/tools/question-templates/${companyId}/${questionId}/answer/`,
        data: { answer },
    });
};
